import React from "react";
import { TileProps } from "./Tile.types";
import { getClassName } from "../../helpers/common.helpers";
import "./TileComponent.scss";

const TileComponent = ({ tileClassname, tileContentClassName, tileContent, tileDetailClassName, tileDetail, onClick }: TileProps) => {
    return <><div className={getClassName("tile", tileClassname ?? "")} >
        <div className={getClassName("tile__content", tileContentClassName ?? "")} onClick={onClick}>{tileContent}</div>
    </div>
        <div className={getClassName("tile-details", tileDetailClassName ?? "")}><span onClick={onClick}>{tileDetail}</span></div></>
}

export default TileComponent;